
    import dynamic from "next/dynamic"
    const AsyncBoundary = dynamic(() => import("./_app.tsx?hasBoundary"), {suspense:true});
    export default AsyncBoundary;
    

    AsyncBoundary.getInitialProps = async (ctx) => {
      return import("./_app.tsx?hasBoundary").then((mod) => {
        const page = mod.default || mod;
        return page.getInitialProps(ctx)
      })
    }
    